var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcTrendingUp24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9186 5.5L19.3401 7.59917L14.1799 12.0725L9.9502 8.40583L2.11475 15.2075L3.6057 16.5L9.9502 11L14.1799 14.6667L20.8416 8.90083L23.2631 11V5.5H16.9186Z",
    fill: "#09AB5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTrendingUp24Px);
export default __webpack_public_path__ + "static/media/ic-trending-up-24px.b386c4b2a362e10055efb45d6132423f.svg";
export { ForwardRef as ReactComponent };